import { combineReducers } from "redux";
import userReducer from "./reducers/auth.reducers";
import spAdminReducer from "./reducers/sp.reducers";
import participantReducer from "./reducers/participant.reducers";
import geenralReducer from "./reducers/general.reducers";
import cosReducer from "./reducers/cos.reducers";
import ahReducer from "./reducers/ah.reducers";
import rosteringReducer from "./reducers/rostering.reducers";
import employeeReducer from "./reducers/employee.reducer";
import silReducer from "./reducers/sil.reducers";
import incidentReducer from "./reducers/incident.reducers";
import auditReducer from "./reducers/audit.reducers";
import journeyReducer from "./reducers/journey.reducers";
import vertex360CopilotReducer from "./reducers/vertex360Copilot.reducers";
import careWatchReducer from "./reducers/careWatch.reducers";
import bulkAnalyseReducer from "./reducers/bulkAnalyse.reducers";

import ACTIONS from "../store/constants";

const appReducer = combineReducers({
  users: userReducer,
  spAdmin: spAdminReducer,
  participant: participantReducer,
  general: geenralReducer,
  cos: cosReducer,
  ah: ahReducer,
  rostering: rosteringReducer,
  employee: employeeReducer,
  sil: silReducer,
  incident: incidentReducer,
  audit: auditReducer,
  journey: journeyReducer,
  vertex360Copilot: vertex360CopilotReducer,
  careWatch: careWatchReducer,
  bulkAnalyse: bulkAnalyseReducer,
});

const rootReducer = (state, action) => {
  let prevState = state;
  if (
    action.type === ACTIONS.LOGOUT.SUCCESS ||
    action.type === ACTIONS.LOGOUT.ERROR
  ) {
    prevState = undefined;
  }

  return appReducer(prevState, action);
};

export default rootReducer;
